import { connect } from 'react-redux';
import { searchPages, create as createPage } from 'web/store/modules/pages';
import { getFlipper } from 'web/store/modules/company';
import { FLIPPER_INTERNATIONALIZATION } from '../../../../constants/flippers';
import AdminAddPageModal from '../components/AdminAddPageModal';

const mapStateToProps = state => ({
  i18nEnabled: getFlipper(state, FLIPPER_INTERNATIONALIZATION),
});

const mapDispatchToProps = dispatch => ({
  onSubmit: pages =>
    dispatch(createPage(pages)).then(() =>
      dispatch(searchPages())),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AdminAddPageModal);
